import React from 'react'

import {
  Accordion as AccessibleAccordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemPanel,
  AccordionItemButton,
} from 'react-accessible-accordion'

import { ExpandMore } from 'images/icons'

interface IProps {
  id?: string
  heading: string
  preExpanded?: boolean
  select?: boolean
  subselect?: boolean
  children: React.ReactNode
  isSelected?: boolean
  onChange?: (id: string | null) => void
}

const Accordion: React.FC<IProps> = (props) => {
  const {
    id,
    preExpanded,
    select,
    subselect,
    heading,
    children,
    isSelected = false,
    onChange,
  } = props

  const [isOpen, setOpen] = React.useState<boolean>(preExpanded || false)

  const handleChange = (value: string[]) => {
    if (onChange) {
      onChange(id ? id : null)
    }

    if (value.length) {
      setOpen(true)
    } else {
      setOpen(false)
    }
  }

  if (select || subselect) {
    return (
      <AccessibleAccordion
        onChange={handleChange}
        allowZeroExpanded
        className={`w-full select-none ${subselect ? 'pl-10' : ''}`}
      >
        <AccordionItem uuid={id}>
          <AccordionItemHeading
            className={`h-30 border-b-1 ${
              subselect ? 'font-400 border-gray-200' : 'font-500 border-black'
            } text-13 tracking-0.1 ${isSelected ? 'text-brand-primary' : 'text-black'}`}
          >
            <AccordionItemButton className="flex justify-between items-center">
              <h2 className="self-center">{heading}</h2>
              {!isOpen ? (
                <ExpandMore />
              ) : (
                <div
                  style={{
                    transform: 'rotate(180deg)',
                  }}
                >
                  <ExpandMore />
                </div>
              )}
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="w-full mt-25 last-child:mb-25">
            {children}
          </AccordionItemPanel>
        </AccordionItem>
      </AccessibleAccordion>
    )
  }
  return (
    <AccessibleAccordion
      preExpanded={preExpanded ? ['1'] : []}
      onChange={handleChange}
      allowZeroExpanded
      className="w-full"
    >
      <AccordionItem uuid="1">
        <AccordionItemHeading className="px-48 pb-22 border-b-1 border-gray-200 h1">
          <AccordionItemButton className="flex justify-between item-center">
            <h2 className="self-center">{heading}</h2>
            {!isOpen ? (
              <ExpandMore size={48} />
            ) : (
              <div
                style={{
                  transform: 'rotate(180deg)',
                }}
              >
                <ExpandMore size={48} />
              </div>
            )}
          </AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel className="w-full mt-45">{children}</AccordionItemPanel>
      </AccordionItem>
    </AccessibleAccordion>
  )
}

export default Accordion
